import { getAllCookies } from "../../Utils/cookies";

function getHeaders() {
  const credentials = getAllCookies();

  return { "Content-Type": "application/json", ...credentials };
}

/** @param {string} url */
const GET = async (url) => {
  const response = await fetch(url, {
    method: "GET",
    headers: getHeaders(),
    credentials: "include",
  });
  const result = await response.json();

  return { result, response };
};

/**
 * @param {string} url
 * @param {{[key: string]: any}} body
 */
const POST = async (url, body) => {
  const response = await fetch(url, {
    method: "POST",
    headers: getHeaders(),
    credentials: "include",
    body: JSON.stringify(body),
  });
  const result = await response.json();

  return { result, response };
};

/**
 * @param {string} url
 * @param {{[key: string]: any}} body
 */
const PUT = async (url, body) => {
  const response = await fetch(url, {
    method: "PUT",
    headers: getHeaders(),
    credentials: "include",
    body: JSON.stringify(body),
  });
  const result = await response.json();

  return { result, response };
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  GET,
  POST,
  PUT,
};
